import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fluent UI Imports
import ConfiguratorStPanel from "./ConfiguratorStPanel";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IKonfigurationSt } from "../../Models/IKonfigurationSt";
import FreigabeDialog from "../FreigabeDialog/FreigabeDialog";
import DeleteConfigurationDialog from "./DeleteConfiguration";
import { helperMethods } from "../../helpers/helperMethods";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  Button,
  MessageBar,
  Overflow,
  OverflowItem,
  Tab,
  TabList,
} from "@fluentui/react-components";
import {
  AddRegular,
  IosArrowRtl24Regular,
  MailArrowDownRegular,
  SaveRegular,
  SettingsRegular,
} from "@fluentui/react-icons";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import { ColumnsConfiST } from "./ColumnsConfiST";
import { useNavigate } from "react-router-dom";
import Header from "../Layout/Header";
import useWindowSize from "../../helpers/useWindowSize";
import OverflowMenu from "../../Controls/OverflowMenu";
import HeaderTextAnimation from "../Layout/HeaderTextAnimation";

function ConfiST() {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const [openConfigs, setOpenConfigs] = useState<IKonfigurationSt[]>([]);
  const [closedConfigs, setClosedConfigs] = useState<IKonfigurationSt[]>([]);
  const [clickedConfig, setClickedConfig] = useState<IKonfigurationSt>();
  const [selectedTabValue, setSelectedTabValue] =
    useState<string>("openConfigs");
  const [freigabeObjectGuid, setFreigabeObjectGuid] = useState<
    undefined | string
  >(undefined);
  const [deleteGuid, setDeleteGuid] = useState<undefined | string>(undefined);
  const [newConfiguration, setNewConfiguration] = useState<boolean>();
  const getMyConfigs = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/configurator/GetMyConfigurations`)
      .then((data: IKonfigurationSt[]) => {
        setOpenConfigs(data.filter((a) => a.status < 100));
        setClosedConfigs(data.filter((a) => a.status == 100));
      });
  };

  useEffect(() => {
    helperMethods.addAccessedModuleCountValue("Configurator");
  }, []);
  useEffect(() => {
    if (newConfiguration == false) {
      getMyConfigs();
    }
  }, [newConfiguration]);

  useEffect(() => {
    if (freigabeObjectGuid == undefined) {
      getMyConfigs();
    }
  }, [freigabeObjectGuid]);
  useEffect(() => {
    if (deleteGuid == undefined) {
      getMyConfigs();
    }
  }, [deleteGuid]);
  useEffect(() => {
    if (openConfigs || closedConfigs) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid && guid != "new") {
            setNewConfiguration(false);
            setClickedConfig(
              selectedTabValue == "openConfigs"
                ? openConfigs.find((x) => x.userObjectGuid == guid)
                : closedConfigs.find((x) => x.userObjectGuid == guid),
            );
          } else if (guid == "new") {
            setClickedConfig(undefined);
            setNewConfiguration(true);
          }
        } else {
          setNewConfiguration(false);
          setClickedConfig(undefined);
        }
      }
    }
  }, [openConfigs, closedConfigs, window.location.search]);
  return (
    <>
      {freigabeObjectGuid != undefined && (
        <FreigabeDialog
          onDismiss={() => {
            setFreigabeObjectGuid(undefined);
          }}
          onSave={() => {
            setFreigabeObjectGuid(undefined);
          }}
          isDialogOpen={freigabeObjectGuid != undefined}
          objectGuid={freigabeObjectGuid}
          objectType="KonfigurationSt"
          referenceGuid=""
        />
      )}

      {deleteGuid != undefined && (
        <DeleteConfigurationDialog
          onDelete={() => {
            setDeleteGuid(undefined);
            getMyConfigs();
          }}
          onDismiss={() => {
            setDeleteGuid(undefined);
          }}
          guid={deleteGuid}
          isDialogOpen={deleteGuid != undefined}
        />
      )}
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1350 ||
              windowSize.width < 1024 ||
              (!clickedConfig && !newConfiguration)) && (
              <Button
                icon={<SettingsRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/configuratorst");
                }}
              >
                {i18n.t<string>("configurator").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1351 &&
              windowSize.width > 1024 &&
              (newConfiguration || clickedConfig) && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/configuratorst");
                  }}
                  appearance="transparent"
                >
                  <SettingsRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {clickedConfig != undefined && (
              <>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button appearance="transparent">
                  {clickedConfig.id}
                  <div style={{ marginLeft: "5px", marginRight: "5px" }}>:</div>

                  <HeaderTextAnimation
                    text={
                      i18n.language.includes("de") &&
                      clickedConfig.positionen[0].artikel?.benennungDE
                        ? clickedConfig.positionen[0].artikel?.benennungDE
                        : clickedConfig.positionen[0].artikel?.benennungEN
                        ? clickedConfig.positionen[0].artikel?.benennungEN
                        : ""
                    }
                  />
                </Button>
              </>
            )}

            {newConfiguration == true && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button appearance="transparent">
                  <HeaderTextAnimation
                    text={i18n.t<string>("newConfiguration")}
                  />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      <ConfiguratorStPanel
        isPanelOpen={clickedConfig != undefined || newConfiguration == true}
        onDismiss={() => {
          navigate("/configuratorst");
          getMyConfigs();
        }}
        config={clickedConfig}
      />
      {!newConfiguration && !clickedConfig && (
        <>
          <div className="lueb-InnerContentBlockPadding2px">
            <Button
              icon={<AddRegular />}
              appearance="transparent"
              onClick={() => {
                navigate("/configuratorst?guid=new");
              }}
            >
              {i18n.t<string>("newConfiguration")}
            </Button>
          </div>
          <Overflow minimumVisible={1}>
            <TabList
              selectedValue={selectedTabValue}
              onTabSelect={(ev, data) => {
                if (typeof data.value == "string") {
                  setSelectedTabValue(data.value);
                }
              }}
            >
              <OverflowItem
                key="openConfigs"
                id="openConfigs"
                priority={"openConfigs" === selectedTabValue ? 2 : 1}
              >
                <Tab icon={<SaveRegular />} value={"openConfigs"}>
                  {i18n.t<string>("openConfigs")}
                </Tab>
              </OverflowItem>
              <OverflowItem
                key="closedConfigs"
                id="closedConfigs"
                priority={"closedConfigs" === selectedTabValue ? 2 : 1}
              >
                <Tab icon={<MailArrowDownRegular />} value={"closedConfigs"}>
                  {i18n.t<string>("closedConfigs")}
                </Tab>
              </OverflowItem>
              {
                <OverflowMenu
                  onTabSelect={(tabId: string) => {
                    setSelectedTabValue(tabId);
                  }}
                  items={[
                    {
                      key: "openConfigs",
                      text: i18n.t<string>("openConfigs"),
                      icon: <SaveRegular />,
                    },
                    {
                      key: "closedConfigs",
                      text: i18n.t<string>("closedConfigs"),
                      icon: <MailArrowDownRegular />,
                    },
                  ].filter((x) => x.key != selectedTabValue)}
                />
              }
            </TabList>
          </Overflow>

          <div className="lueb-ContentBlock">
            <LuebPagedDataGrid
              columns={ColumnsConfiST({
                openDialogWithConfig: (item) => {
                  /* setClickedConfig(item); */
                  if (item.userObjectGuid != undefined) {
                    navigate("/configuratorst?guid=" + item.userObjectGuid);
                  }
                },
                onFreigabeObjectGuid: (item: string) => {
                  setFreigabeObjectGuid(item);
                },
                onDeleteGuid: (item: string) => {
                  setDeleteGuid(item);
                },
              })}
              items={
                selectedTabValue == "openConfigs" ? openConfigs : closedConfigs
              }
              resizableColumns={true}
              sortable
              columnSizingOptions={{
                actionsId: { minWidth: 80, defaultWidth: 100 },
                configId: { minWidth: 80, defaultWidth: 100 },
              }}
            />
            {((selectedTabValue == "openConfigs" && openConfigs.length == 0) ||
              (selectedTabValue == "closedConfigs" &&
                closedConfigs.length == 0)) && (
              <MessageBar intent="info">
                {i18n.t<string>("noItemsFound")}
              </MessageBar>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default ConfiST;
